import axios from "axios";
import { ApplicationPaths } from "../components/api-authorization/ApiAuthorizationConstants";
import authService from "../components/api-authorization/AuthorizeService";

const BASE_URL = "";
const TIMEOUT = 60000;

const transformRequestOptions = (params) => {
  let options = "";
  for (const key in params) {
    if (typeof params[key] !== "object" && params[key]) {
      options += `${key}=${params[key]}&`;
    } else if (
      typeof params[key] === "object" &&
      params[key] &&
      params[key].length
    ) {
      params[key].forEach((el) => {
        options += `${key}=${el}&`;
      });
    }
  }
  return options ? options.slice(0, -1) : options;
};

const request = axios.create({});

request.interceptors.request.use(async (config) => {
  config.paramsSerializer = (params) => transformRequestOptions(params);
  const token = await authService.getAccessToken();
  config.headers.common.Authorization = `Bearer ${token}`;
  config.baseURL = BASE_URL;
  config.timeout = TIMEOUT;
  return config;
});

request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    //const originalRequest = error.config;

    if (isAuthError(error)) {
      // TO DO: refresh token
      const redirectUrl = `${ApplicationPaths.Login}`;
      window.location.href = redirectUrl;
      return Promise.reject(error.response);
    }

    let errorRes = error.response;

    errorRes.data = {
      error: error.response.data,
    };

    return Promise.reject(errorRes);
  }
);

function isAuthError(error) {
  return error.response && error.response.status === 401;
}

export default request;
